import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import {
	type FuturePortfolioCreateRequestDTO,
	type GoalFuturePortfolioResponseDTO,
	postFuturePortfoliosV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useFuturePortfolioCreateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<
		GoalFuturePortfolioResponseDTO,
		Error,
		FuturePortfolioCreateRequestDTO
	>({
		mutationFn: processResponse((body: FuturePortfolioCreateRequestDTO) =>
			postFuturePortfoliosV2(body),
		),
		onSuccess: (_data, { goalId }) =>
			queryClient.invalidateQueries({
				queryKey: GoalsKeys.detail(goalId),
			}),
	});
};
